module.exports = __webpack_public_path__ + "static/media/wp_tutorial_image_2.15872373.png";